import { FormattedMessage, useIntl } from "react-intl";
import View from "components/utils/View";
import { Grid } from "@material-ui/core";
import { BankLogo } from "components/utils";
import { Typography } from "components/common";
import { ImgWithFallback } from "components";
import { MainItemsLayout } from "components/Layout";
import useStyles from "./readerStyles";
import { SrButton, SrTitle } from "../../../common";

const Reader = () => {
  const classes = useStyles();
  const intl = useIntl();

  const goBuyReader = () => {
    window.open("https://shop.senorpago.com/pinpadmini", "_blank");
  };

  return (
    <View translateTitleKey="menu.reader">
      <SrTitle>
        <FormattedMessage id="terminals.title" />
      </SrTitle>
      <MainItemsLayout
        leftContent={
          <div>
            <Typography variant="h3SemiBold" className={classes.paraHead}>
              <FormattedMessage id="terminals.primaryFeatureA" />
            </Typography>
            <Typography variant="h3SemiBold" className={classes.paraSubHead}>
              <FormattedMessage id="terminals.primaryFeatureB" />
            </Typography>
            <ul className={classes.list}>
              <li className={classes.listItem}>
                <Typography variant="body1">
                  <FormattedMessage id="terminals.featureA" />
                </Typography>
              </li>
              <li className={classes.listItem}>
                <Typography variant="body1">
                  <FormattedMessage id="terminals.featureB" />
                </Typography>
              </li>
              <li className={classes.listItem}>
                <Typography variant="body1">
                  <FormattedMessage id="terminals.featureC" />
                </Typography>
              </li>
              <li className={classes.listItem}>
                <Typography variant="body1">
                  <FormattedMessage id="terminals.featureD" />
                </Typography>
              </li>
              <li className={classes.listItem}>
                <Typography variant="body1">
                  <FormattedMessage id="terminals.featureE" />
                </Typography>
              </li>
            </ul>
            <SrButton
              className={classes.btnBuy}
              variant="contained"
              color="primary"
              onClick={goBuyReader}
            >
              <FormattedMessage id="terminals.action" />
            </SrButton>
          </div>
        }
        rightContent={
          <ImgWithFallback
            src="/reader/lector.webp"
            fallback="/reader/lector.png"
            alt={intl.formatMessage({
              id: "terminals.image",
            })}
            className={classes.readerImg}
          />
        }
      />
      <Grid container spacing={3} className={classes.conainerLogos}>
        <Grid item xs={12}>
          <BankLogo bankName="cardVisa" className={classes.bankLogo} />
          <BankLogo bankName="cardMasterCard" className={classes.bankLogo} />
          <BankLogo bankName="cardAmex" className={classes.bankLogo} />
          <BankLogo bankName="cardCarnet" className={classes.bankLogo} />
          <BankLogo bankName="cardUpSivale" className={classes.bankLogo} />
          <BankLogo bankName="cardSodexo" className={classes.bankLogo} />
          <BankLogo bankName="cardEdenred" className={classes.bankLogo} />
          <BankLogo bankName="cardToka" className={classes.bankLogo} />
        </Grid>
      </Grid>
    </View>
  );
};

export default Reader;
